import { AccountNumber } from '../utils/urlResolver';
import axios from '.';

export const getAccountNumber = (data) => {
  return axios({
    method: 'POST',
    url: AccountNumber.listing,
    data,
  });
};

export const getEntityList = () => {
  return axios({
    method: 'GET',
    url: AccountNumber.entityList,
  });
};

export const getTotalAccountNumber = (data) => {
  return axios({
    method: 'POST',
    url: AccountNumber.count,
    data,
  });
};

export const createAccountNumber = (data) => {
  return axios({
    method: 'POST',
    url: AccountNumber.add,
    data,
  });
};

export const editAccountNumber = (data) => {
  return axios({
    method: 'PUT',
    url: AccountNumber.edit,
    data,
  });
};

export const getSegmentValue = (params) => {
  return axios({
    method: 'GET',
    url: AccountNumber.searchSegment,
    params,
  });
};
